<template lang="html">
  <div class="create-profile-wrapper">
    <div class="form-progress-wrap edit-profile basic-info-wrap">
      <BaseLoading  :spinning="collegeLoading">
        <div class="container">
          <div class="steps-content">
            <div class="general-form-wrap">
              <div class="general-form">
                <div class="image-upload box-wrapper">
                  <div class="heading">
                    <h2 class="form-title">Upload College Profile Picutre or Logo</h2>
                  </div>
                  <BaseDragUpload
                    cannot-delete
                    label="Click this area to upload or change photo"
                    class="drag-image-wrapper"
                    @file-upload="
                      image => {
                        imageSrc = image;
                      }
                    "
                    :imageUrl="imageUrl"
                  />
                </div>
                <FormModel
                  :model="resource"
                  ref="form"
                  @submit.prevent.native="handleFormSubmit"
                  class="basic-information-form-wrapper"
                  :rules="validationRules"
                >
                  <div class="general-info box-wrapper">
                    <div class="heading">
                      <h2 class="form-title">Basic Information</h2>
                    </div>
                    <a-row :gutter="32">
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          ref="collegeName"
                          :value="resource.collegeName"
                          label="College Name"
                          placeholder="Enter name"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'collegeName'
                              )
                          "
                          name="collegeName"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          ref="collegePhone"
                          :value="resource.collegePhone"
                          label="Phone Number"
                          placeholder="Phone Number"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'collegePhone'
                              )
                          "
                          name="collegePhone"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          :value="resource.url"
                          label="College Page Url"
                          placeholder="College Page Url"
                          @change="
                            event =>
                              handleFormValueChange(event.target.value, 'url')
                          "
                          name="url"
                        />
                      </a-col>
                      <a-col :sm="24">
                        <BaseFormInput
                          :value="resource.description"
                          label="Enter College Description"
                          placeholder="Enter College Description"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'description'
                              )
                          "
                          name="description"
                          type="textarea"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseTaxonomySelect
                          resource="schoolType"
                          placeholder="Select School Type"
                          type="School Type"
                          label="School Type (Click x to clear selection)"
                          extra-value
                          allow-clear
                          :value="resource.schoolTypeId || undefined"
                          @change="
                            value =>
                              handleFormValueChange(value, 'schoolTypeId')
                          "
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseTaxonomySelect
                          resource="educationType"
                          placeholder="Select Education Type"
                          type="Education Type"
                          label="Education Type (Click x to clear selection)"
                          extra-value
                          allow-clear
                          :value="resource.schoolEducationTypeId || undefined"
                          @change="
                            value =>
                              handleFormValueChange(
                                value,
                                'schoolEducationTypeId'
                              )
                          "
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseTaxonomySelect
                          resource="collegeSetting"
                          placeholder="Select College Setting"
                          type="College Setting"
                          label="College Setting (Click x to clear selection)"
                          extra-value
                          allow-clear
                          :value="resource.collegeSettingId || undefined"
                          @change="
                            value =>
                              handleFormValueChange(value, 'collegeSettingId')
                          "
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          :value="resource.schoolTuition"
                          label="School Tuition"
                          type="number"
                          placeholder="Enter School Tuition"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'schoolTuition'
                              )
                          "
                          name="schoolTuition"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          :value="resource.schoolEnrollment"
                          label="School Enrollment"
                          type="number"
                          placeholder="Enter School Enrollment"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'schoolEnrollment'
                              )
                          "
                          name="schoolEnrollment"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          :value="resource.url1"
                          label="Softball Website url"
                          placeholder="Softball Website url"
                          @change="
                            event =>
                              handleFormValueChange(event.target.value, 'url1')
                          "
                          name="url"
                        />
                      </a-col>
                    </a-row>
                  </div>
                  <div class="general-info box-wrapper">
                    <div class="heading">
                      <h2 class="form-title">Location Information</h2>
                    </div>
                    <a-row :gutter="32">
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          ref="city"
                          :value="resource.city"
                          label="City"
                          placeholder="Enter City"
                          @change="
                            event =>
                              handleFormValueChange(event.target.value, 'city')
                          "
                          name="city"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseSortedTaxonomySelect
                          ref="state"
                          resource="collegeState"
                          placeholder="Enter State"
                          type="College State"
                          label="State"
                          :value="resource.stateId"
                          @change="
                            value => handleFormValueChange(value, 'stateId')
                          "
                          name="state"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          ref="zip"
                          :value="resource.zip"
                          label="ZIP"
                          placeholder="Enter zip"
                          @change="
                            event =>
                              handleFormValueChange(event.target.value, 'zip')
                          "
                          name="zip"
                        />
                      </a-col>
                      <a-col :sm="24" :md="9">
                        <BaseFormInput
                          ref="address1"
                          :value="resource.address1"
                          label="Address"
                          placeholder="Address"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'address1'
                              )
                          "
                          name="address1"
                        />
                      </a-col>
                    </a-row>
                  </div>
                  <div class="general-info box-wrapper">
                    <div class="heading">
                      <h2 class="form-title">Social Media Links</h2>
                    </div>
                    <a-row :gutter="32">
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          :value="resource.facebook"
                          label="Facebook"
                          placeholder="Enter Facebook Link"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'facebook'
                              )
                          "
                          name="Facebook"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          placeholder="Enter Twitter Link"
                          label="Twitter"
                          :value="resource.twitter"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'twitter'
                              )
                          "
                          name="twitter"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          :value="resource.flickr"
                          label="Flicker"
                          placeholder="Enter Flicker Link"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'flickr'
                              )
                          "
                          name="flickr"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          :value="resource.youtube"
                          label="Youtube"
                          placeholder="Enter Youtube Link"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'youtube'
                              )
                          "
                          name="youtube"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          :value="resource.linkedin"
                          label="Linkedin"
                          placeholder="Enter Linkedin Link"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'linkedin'
                              )
                          "
                          name="linkedin"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          :value="resource.podcast"
                          label="Podcast"
                          placeholder="Enter Podcast Link"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'podcast'
                              )
                          "
                          name="podcast"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          :value="resource.instagram"
                          label="Instagram"
                          placeholder="Enter Instagram Link"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'instagram'
                              )
                          "
                          name="instagram"
                        />
                      </a-col>
                    </a-row>
                  </div>
                  <div class="general-info box-wrapper">
                    <div class="heading">
                      <h2 class="form-title">Additional Information</h2>
                    </div>
                    <a-row :gutter="32">
                      <a-col :sm="24">
                        <BaseFormInput
                          :value="resource.info"
                          label="Additional Info"
                          placeholder="Enter Additional Info"
                          @change="
                            event =>
                              handleFormValueChange(event.target.value, 'info')
                          "
                          name="info"
                          class="custom-height-info"
                          type="textarea"
                        />
                      </a-col>
                      <a-col :sm="24">
                        <BaseFormInput
                          :value="resource.conference"
                          label="Conference"
                          placeholder="Enter Conference"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'conference'
                              )
                          "
                          name="conference"
                          type="textarea"
                        />
                      </a-col>
                    </a-row>
                  </div>
                  <div class="margined-content margin-t-1">
                    <BaseButton
                      type="primary"
                      html-type="submit"
                      :loading="collegeLoading"
                    >
                      Submit
                    </BaseButton>
                  </div>
                </FormModel>
              </div>
            </div>
          </div>
        </div>
      </BaseLoading>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FormModel } from "ant-design-vue";
import { College } from "@/models";

const STORE_KEY = "collegeStore";

export default {
  data() {
    return {
      resource: new College(),
      imageSrc: "",
      imageUrl: "",
      validationRules: College.validationRules,
      form: this.$form.createForm(this)
    };
  },
  components: {
    FormModel
  },
  mounted() {
    this.$store.dispatch(`${STORE_KEY}/getCollege`, {
      id: localStorage["college-id"]
    });
  },
  methods: {
    handleFormValueChange(value, key) {
      this.resource = new College({ ...this.resource, [key]: value });
    },
    async handleFormSubmit() {
      let collegeData = {
        id: this.resource.id,
        collegeName: this.resource.collegeName,
        url: this.resource.url,
        url1: this.resource.url1,
        description: this.resource.description,
        city: this.resource.city,
        info: this.resource.info,
        schoolType: this.resource.schoolTypeId,
        schoolEducationType: this.resource.schoolEducationTypeId,
        collegePhone: this.resource.collegePhone,
        zip: this.resource.zip,
        address1: this.resource.address1,
        state: this.resource.stateId,
        schoolTuition: this.resource.schoolTuition,
        schoolEnrollment: this.resource.schoolEnrollment,
        collegeSetting: this.resource.collegeSettingId,
        conference: this.resource.conference,
        facebook: this.resource.facebook,
        instagram: this.resource.instagram,
        twitter: this.resource.twitter,
        flickr: this.resource.flickr,
        youtube: this.resource.youtube,
        podcast: this.resource.podcast,
        linkedin: this.resource.linkedin,
        slug: "collegeprofile"
      };
      for (let key in collegeData) {
        if (
          collegeData[key] === "-" ||
          collegeData[key] == null ||
          collegeData[key] === ""
        ) {
          collegeData[key] = null;
        }
      }
      this.$refs.form.validate(async (valid, error) => {
        if (!valid) this.$refs[Object.keys(error)[0]].$refs.formInput.focus();
        if (valid) {
          await this.$store.dispatch(`${STORE_KEY}/updateCollege`, collegeData);
          let formData = new FormData();
          formData.append("logo", this.imageSrc);
          this.imageSrc &&
            (await this.$store.dispatch(`${STORE_KEY}/updateCollegeLogo`, {
              id: this.resource.id,
              image: formData
            }));
          await this.$store.dispatch(`${STORE_KEY}/getCollege`, {
            id: localStorage["college-id"]
          });
          this.imageSrc = "";
        }
      });
    }
  },
  computed: {
    ...mapGetters({
      college: `${STORE_KEY}/college`,
      collegeLoading: `${STORE_KEY}/collegeLoading`
    })
  },
  watch: {
    college(newVal, _) {
      this.resource = new College(newVal);
      this.imageUrl = newVal.logo;
    }
  }
};
</script>

<style lang="scss">
.custom-height-info {
  .cust-form-input {
    height: 20rem !important;
  }
}
</style>
